module.exports = __webpack_public_path__ + "img/Stachelschwein.b3694747.svg";